/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Compare_Full_ScreenInputs */



/**
* | output |
* | --- |
* | "Full-screen charts" |
*
* @param {Pricing_Compare_Full_ScreenInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_compare_full_screen = /** @type {((inputs?: Pricing_Compare_Full_ScreenInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Compare_Full_ScreenInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Графики на весь экран")
	return /** @type {LocalizedString} */ ("Full-screen charts")
});